// extracted by mini-css-extract-plugin
export var alertIcon = "_pq-0";